<script>
import PageIndicator from '@components/page-indicator.vue'

export default {
  components: { PageIndicator },
  props: {
    title: {
      type: String,
      required: true,
    },
    page: {
      type: [Number, Boolean],
      default: false,
    },
  },
}
</script>

<template>
  <div :class="$style.header">
    <PageIndicator v-if="page || page === 0" :index="page" />
    <h2 v-text="title" />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.header {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 12px 0;
  text-align: center;
  width: 100%;

  h2 {
    max-width: 260px;
  }
}
</style>
